<script>
    import {Polygon} from "vue2-google-maps";

    export default {
        extends: Polygon,
    }
</script>
